// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__a6IZZ","col":"styles_col__d4AKJ"};